import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { ActivatedRoute, Router } from '@angular/router'
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { Console, debug } from 'console';
import { differenceInCalendarDays,addDays,parseISO,format,differenceInDays } from 'date-fns';
import { promise } from 'protractor';
import { id_ID } from 'ng-zorro-antd/i18n';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { Observable  } from 'rxjs';

interface WHQMaintainDto {
  Pono: string;
  Currency: string;
  InvoiceDate: string;
  InvoiceAmount: string;
  InvoiceNo: string;
  Taxes: string;
  remake: string;
}
@Component({
  selector: 'app-edit-wmsm-StatementMaintainWHQ',
  templateUrl: './edit-wmsm-StatementMaintainWHQ.component.html',
  styleUrls: ['./edit-wmsm-StatementMaintainWHQ.component.css']
})
export class EditWmsmStatementMaintainWHQComponent extends BaseComponent implements OnInit {
  fileList: NzUploadFile[] = [];
  loading: boolean = false;

  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  validateForm: FormGroup;
  validateForm2: FormGroup;
  showFiles:boolean;
  i = 0;
  editId: Number | null = 0;
  dateFormat = 'yyyy/MM/dd';
  FirstInvoiceDate;
  RNO: any;
  Pono: string;
  Currency: any;
  Company: any;
  disabledPONO: boolean = false;
  InvoiceSerialNumberIsNull: boolean = true;
  InvoiceInfo: any[] = [];
  ReceiptInfo: any[] = [];
  SubmitInvoiceInfo: any[] = [];
  SubmitReceiptInfo: any[] = []
  GetMaintainData: any;
  invoiceNo: any;
  Filename:any;
  otd1_Visible: boolean;
  otd2_Visible: boolean;
  Vendor_Punctual_Visible: boolean;
  Delay_Visible: boolean
  inputvalue: string;
  IsInputValue: boolean = false;
  tw: boolean;
  cn: boolean;
  en: boolean;
  InvoiceDatevalue: boolean = false;
  NontaxInvoiceAmountvalue: boolean = false;
  Taxesvalue:boolean=false;
  today = new Date();
  nzShowButton: boolean = true;
  Uploadfilelink:any;
  InvoiceNodata:any;
  uploadfilename:any;
  Submitdata:any[] = [];
  Role:string;
  ChangeValue:any;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  InvoiceInfoSerialNumberList: any[] = [];
  SerialNumberInInvoice: boolean = true;
  count = 0;
  InvoiceCodeIsNull: boolean = true;
  InvoiceNoIsNull: boolean = true;
  rowID:any;
  booleaninvoiceno:boolean;
  uploadValue:boolean;
  disabledfile:boolean;
  index: number;
  DisabledElectronicInvoice:boolean = false;
  DisabledManualInvoice:boolean = false;
  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private messageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,) 
    { super() }




  
async ngOnInit() {
    this.loading =true
      setTimeout(() => {
        this.ActivatedRoute.queryParams.subscribe(params => {
          this.index =  0
        })
        // this.ActivatedRoute.queryParams.subscribe(params => {
        //   this.DisabledElectronicInvoice = params['DisabledElectronicInvoice']
        // })
        // this.ActivatedRoute.queryParams.subscribe(params => {
        //   this.DisabledManualInvoice = params['DisabledManualInvoice']
        // })
      }, 50);
    
    this.loading =false
  }

 }